<template>
  <div class="layout">
    <!-- 手机端遮罩层 -->
    <div v-if="sidebarOpen" class="sidebar-overlay" @click="sidebarOpen = false"></div>
    <Sidebar :class="{ 'sidebar-mobile-open': sidebarOpen }" />
    <div class="main">
      <Header @toggle-sidebar="sidebarOpen = !sidebarOpen" />
      <div class="content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ref } from 'vue'
import Sidebar from './Sidebar.vue'
import Header from './Header.vue'

export default {
  name: "LayoutBackend",
  components: {
    Sidebar,
    Header
  },
  setup() {
    const sidebarOpen = ref(false)
    return { sidebarOpen }
  }
}
</script>

<style scoped>
.layout {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
.main {
  flex: 1;
  background: #f5f7fa;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.content {
  flex: 1;
  padding: 20px;
  overflow: auto;
  box-sizing: border-box;
}
.sidebar-overlay {
  display: none;
}

/* 手机端响应式 */
@media (max-width: 768px) {
  .sidebar-container {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
  
  .sidebar-container.sidebar-mobile-open {
    transform: translateX(0);
  }
  
  .sidebar-overlay {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}
</style>